import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=56189934"
import script from "./memo.vue?vue&type=script&lang=ts"
export * from "./memo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports